<template>
    <b-modal id="customer-show-pharma" ref="modal" :title="dialog_title" hide-footer>
        <div class="form-group row">
            <div class="col">
                <input type="text" class="form-control" v-model="title" id="pharma_title">
                <label for="pharma_title" class="wabident-info">Nombre del fármaco</label>
            </div>
        </div>

        <div class="form-group row">
            <div class="col">
                <input type="text" class="form-control" v-model="form" id="pharma_form">
                <label for="pharma_form" class="wabident-info">Forma farmacéutica</label>
            </div>
        </div>

        <div class="form-group row">
            <div class="col">
                <input type="number" class="form-control" v-model="units" id="pharma_units">
                <label for="pharma_units" class="wabident-info">Unidades por envase</label>
            </div>
        </div>

        <div class="row form-group">
            <div class="col text-center">
                <button @click="submitDocument" class="btn btn-primary btn-wabident vertical-align-middle"
                    :disabled="!is_valid || is_loading">
                    <span v-if="is_loading">
                        Guardando
                        <i class="fas fa-spin fa-circle-notch"></i>
                    </span>
                    <span v-else-if="is_editing">Modificar Fármaco</span>
                    <span v-else>Guardar Fármaco</span>
                </button>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    data() {
        return {
            is_loading: false,
            pharma_id: null,
            title: '',
            form: '',
            units: 0,
        }
    },
    computed: {
        is_valid() {
            return this.title !== '';
        },
        is_editing() {
            return this.pharma_id !== null;
        },
        dialog_title() {
            return this.is_editing ? 'Modificar Fármaco' : 'Crear Fármaco';
        },
        ...mapGetters(['clinic', 'errowindow', 'msgwindow'])
    },
    methods: {
        getParams() {
            return {
                title: this.title,
                form: this.form,
                units: this.units,
            };
        },
        submitDocument() {
            if (this.is_loading) {
                return;
            }

            this.is_loading = true;
            const params = this.getParams()
            const url = this.is_editing ? `/clinic/${this.clinic.id}/pharmaceuticals/${this.pharma_id}` : `/clinic/${this.clinic.id}/pharmaceuticals`;

            axios.post(url, params).then((response) => {
                this.msgwindow.success('Fármaco guardado con éxito');
                this.$emit('submit');
                this.$refs.modal.hide();
            }).catch((error) => {
                console.log('[submitDocument] ERROR: ' + error);
                this.errorwindow.sow('Error', 'Error subiendo Fármaco');
            }).then(() => {
                this.is_loading = false;
            })
        },
        showNew() {
            this.is_loading = false;
            this.pharma_id = null;
            this.title = '';
            this.form = '';
            this.units = 0;
            this.$refs.modal.show();
        },
        showEdit(pharma) {
            this.is_loading = false;
            this.pharma_id = pharma.id;
            this.title = pharma.title;
            this.form = pharma.form;
            this.units = pharma.units;
            this.$refs.modal.show();
        }
    },
}
</script>